import { InjectionToken } from '@angular/core';

export interface Environment {
  NAME: string;
  TYPE: 'PROD' | 'QA' | 'DEV' | 'E2E';
  API_URL: string;
  SERVER_UP_CHECK_URL: string;
  GOOGLE_MAPS_API_KEY?: string;
  API_URL_DATA_REQUESTS?: string;
  API_URL_FLEXSPLICE?: string;
}

export interface AppData {
  CLIENT_DESCRIPTION: string;
  HEADING: string;
  DESCRIPTION: string;
  ORG_ID?: string;
  BASE_REGION_NZ?: string;
  LEGACY_USERS_ENABLED: boolean;
  SUPPORT_EMAIL: string;
}

export interface AuthenticationProvider {
  MOCK: boolean;
  PROVIDER: string;
  POOL: string;
  CLIENT_ID: string;
  AUTHENTICATION_DOMAINS: Array<string>;
  COGNITO_AUTHENTICATION_DOMAIN: string;
}

export const ENVIRONMENT_TYPE = new InjectionToken<string>('environmentType');
export const ENVIRONMENT_NAME = new InjectionToken<string>('environmentName');
export const GOOGLE_MAPS_API_KEY = new InjectionToken<string>('googleMapsApiKey');

/**
 * This is the API for the *-we-jsp applications.
 */
export const API_URL = new InjectionToken<string>('API URL PLATFORM');
/**
 * portal-web-data-requests
 */
export const API_URL_DATA_REQUESTS = new InjectionToken<string>('API DATA REQUESTS URL');
/**
 * New URL for the flexsplice project so we can be consistent with the other projects and keep API_URL as the same
 * project base.
 */
export const API_URL_FLEXSPLICE = new InjectionToken<string>('API FLEXSPLICE URL');
/**
 * Will be either API_URL or API_URL_FLEXSPLICE depending on the project.
 */
export const API_URL_USERS = new InjectionToken<string>('API USERS URL');
export const SERVER_UP_CHECK_URL = new InjectionToken<string>('SERVER UP CHECK URL');

export const APP_DATA = new InjectionToken<any>('Application data');

export const AUTHENTICATION_PROVIDER = new InjectionToken<any>('Authentication provider details');
